import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spin } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import SVGIcon from "../../../../utils/SVGIcon";
import { EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../store/app";
import {
  fetchInternalNumber,
  getInternalCodeList,
  updateInternalNumber,
} from "../../../../store/NumberManagementSlice";
import { CONSTANT } from "../../../../config/Constant";
import { useNavigate } from "react-router-dom";

const InternalRoutingForm: React.FC<any> = ({ mode, messageAction }) => {
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const [providerListCode, setProviderListCode] = useState<any>([]);
  const navigate = useNavigate();

  const updateProviderListCode = () => {
    // let updateProvider = {id:"", lable:""}
    const payload = {
      current: 0,
      page_size: 0,
      // user_id: '661e722d74bca72daa7d1a3b',
    };
    dispatch(getInternalCodeList(payload))
      .then((res: any) => {
        const response =
          res?.data?.length > 0
            ? res?.data?.map((item: any) => ({
                id: `${item?.code}`,
                lable: `${item?.code} - ${item?.code_name}`,
              }))
            : []; //res?.data.map((item: any) => console.log('item?.code', item))

        setProviderListCode(response);
      })
      .catch((error: any) => {
        setProviderListCode([]);
      });
  };

  // const InquireNumberAction = (payload: any) => {
  //   dispatch(fetchInquireNumberAction(payload))
  //     .then((res: any) => {
  //       form.resetFields();
  //       setLoading(false);
  //     })
  //     .catch((error: any) => {
  //       setLoading(false);
  //     });
  // };

  // const handleSubmit = async (data) => {
  //   // setLoading(true);

  //   // if (data?.message_action === 'Check') {
  //   console.log('mode', mode);

  //   // Handle the submission based on mode
  //   if (mode === 'add') {
  //     // Code to handle add action
  //     fetchInternalNumber(data);
  //   } else if (mode === 'update') {
  //     // Code to handle update action
  //     updateInternalNumber(data);
  //   }
  // };

  const handleSubmit = (data?: any) => {
    setLoading(true);
    // const payload = {
    //   ...data,
    //   current: data?.current ?? paginationData?.current ?? 1,
    //   page_size: data?.page_size ?? paginationData?.page_size ?? 10,
    // };

    if (mode === "add") {
      dispatch(fetchInternalNumber(data))
        .then((res: any) => {
          console.log("response add", res);
          // setInquireListData(res?.data);
          // setListData(res?.data);
          // setTotalData(res?.total_data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else if (mode === "update") {
      dispatch(updateInternalNumber(data))
        .then((res: any) => {
          console.log("response edit", res);
          // setInquireListData(res?.data);
          // setListData(res?.data);
          // setTotalData(res?.total_data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };
  const runWebSocket = (ws: any) => {
    ws.onopen = function () {
      console.log("WebSocket connection established");
    };

    ws.onclose = function () {
      console.log("WebSocket connection closed");
    };

    ws.onmessage = function (event) {
      const eventData = JSON.parse(event.data);
      const token = localStorage.getItem("token");
      if (token === null) {
        navigate("/login");
      }

      const getNumber = eventData?.user_id || eventData?.user_id1;

      if (getNumber) {
        updateProviderListCode();
      } else {
        ws.close();
      }
    };
  };

  useEffect(() => {
    form.setFieldValue("message_action", messageAction);
  }, [form, messageAction]);

  useEffect(() => {
    const ws = new WebSocket(CONSTANT.WS_URL);
    runWebSocket(ws);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log("providerListCode", providerListCode);

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
        initialValues={{
          status: "in use for client",
          payment_type: "postpaid",
          subsription_type: "business",
          type_of_service: "regular",
        }}
      >
        <Row gutter={[20, 0]} align={"bottom"}>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Text
              label="Number"
              name={"number"}
              tooltip="A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)"
              required
              rules={[
                validations.required.text("Number"),
                // validations.pattern.numericWithSecial,
                validations.pattern.multiplenumber,
                // validations.pattern.whitespace,
              ]}
            />
          </Col>
          {/* <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Text
              label='Provider Code'
              name={'provider_code'}
              tooltip='A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)'
              required
            //   rules={[validations.required.text('Number')]}
            />
          </Col> */}
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Select
              label="Provider Code"
              name={"provider_code"}
              allowClear
              showSearch
              placeholder="Select Provider Code"
              tooltip="Select on from provided network provider list"
              // onFocus={() => console.log('providerListCode', providerListCode?.length)}
              onFocus={() =>
                providerListCode?.length > 0 ? null : updateProviderListCode()
              }
              notFoundContent={providerListCode?.length > 0 ? null : <Spin />}
              options={{
                list: providerListCode ?? [],
                valueKey: "id",
                textKey: "lable",
              }}
              required
              rules={[validations.required.select("Provider Code")]}
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Select
              label="Status"
              name={"status"}
              allowClear
              showSearch
              placeholder="Select Status"
              tooltip="Select Status from list"
              options={{
                list: CONSTANT.INTERNAL_NUMBER_ROUTING_STATUS ?? [],
                valueKey: "id",
                textKey: "label",
              }}
              required
              rules={[validations.required.select("Status")]}
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Select
              label="Payment Type"
              name={"payment_type"}
              allowClear
              showSearch
              placeholder="Select Payment Type"
              tooltip="Select Payment Type from list"
              options={{
                list: CONSTANT.INTERNAL_NUMBER_ROUTING_PAYMENT_TYPE ?? [],
                valueKey: "id",
                textKey: "label",
              }}
              required
              rules={[validations.required.select("Payment Type")]}
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Select
              label="Subscription Type"
              name={"subsription_type"}
              allowClear
              showSearch
              placeholder="Select Subscription Type"
              tooltip="Select Subscription Type from list"
              options={{
                list: CONSTANT.INTERNAL_NUMBER_ROUTING_SUBSCRIPTION_TYPE ?? [],
                valueKey: "id",
                textKey: "label",
              }}
              required
              rules={[validations.required.select("Subscription Type")]}
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Select
              label="Type Of Service"
              name={"type_of_service"}
              allowClear
              showSearch
              placeholder="Select Type Of Service"
              tooltip="Select Type Of Service from list"
              options={{
                list: CONSTANT.INTERNAL_NUMBER_ROUTING_TYPE_OF_SERVICE ?? [],
                valueKey: "id",
                textKey: "label",
              }}
              required
              rules={[validations.required.select("Type Of Service")]}
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Text
              label="Client Name"
              name={"client_name"}
              tooltip="Name of the client"
              required
              rules={[validations.required.select("Client Name")]}
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Text
              label="Client Id"
              name={"client_id"}
              tooltip="ID of the client of any legal type"
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Select
              label="Internal Service"
              name={"internal_service"}
              allowClear
              showSearch
              placeholder="Select Internal Service"
              tooltip="Select Internal Service from list"
              options={{
                list: CONSTANT.INTERNAL_NUMBER_ROUTING_INTERNAL_SERVICE ?? [],
                valueKey: "id",
                textKey: "label",
              }}
              required
              rules={[validations.required.select("Internal Service")]}
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Text
              label="Internal Attribs"
              name={"internal_attribs"}
              tooltip="Additional attributes that Paycall wish to have on this number (not for external usage)"
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Text
              label="External Attribs"
              name={"external_attribs"}
              tooltip="Additional attributes that were requested by external organisations"
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Text
              label="Comments"
              name={"comments"}
              tooltip="Internal comments on the attributes if needed"
            />
          </Col>
          <Col xs={12} md={12} lg={6} xl={4}>
            {/* <Form.Item label=' '> */}
            <Button type="primary" htmlType="submit" loading={loading}>
              {mode === "add" ? (
                <SVGIcon icon="add" color="#fff" width={55} />
              ) : (
                <EditOutlined />
              )}{" "}
              {mode === "add" ? "Add" : "Update"}
            </Button>
            {/* </Form.Item> */}
          </Col>
          <Col xs={12} md={12} lg={6} xl={4}>
            {/* <Form.Item label=' '> */}
            <Button type="default" htmlType="reset">
              Clear
            </Button>
            {/* </Form.Item> */}
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default InternalRoutingForm;
